import React from "react";

/**
 * A reusable large-metric display style used across the site (e.g. "$500M+", "100%", "1,300%", "+10X").
 * Matches the styling used in the private equity dashboard.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Content to render inside the metric.
 * @param {string} [props.className] - Additional class names.
 * @param {string} [props.as] - HTML element/tag to render (default: "span").
 */
const MetricValue = ({ children, className = "", as: Component = "span", ...props }) => (
  <Component
    className={["pe-card__headline-value", className].filter(Boolean).join(" ")}
    {...props}
  >
    {children}
  </Component>
);

export default MetricValue;
